<template>
  <div>
    <div class="card">

      <div class="card-content pl-4 pr-4">
        <v-row class="pa-4" justify="space-between">
          <legend>Informe de registro</legend>
        </v-row>
        <v-row class="pa-4 mt-0" justify="space-between">
          <v-col cols="6">
            <v-select v-model="log"
                      :items="logList"
                      placeholder="Seleccione un registro"
                      item-text="nombre"
                      item-value="nombre"
                      return-object
                      hide-details
                      single-line
                      class=" p-0 m-0 ml-3"
                      @change="getJsonFile"></v-select>

          </v-col>
          <v-col class="text-right m-0" tag="strong" cols="3">
            <v-select
                      v-model="periodo"
                      :items="periodos_"
                      placeholder="Periodo"
                      item-text="year"
                      item-value="year"
                      hide-details
                      single-line
                      class=" p-0 m-0 ml-3"
                      @change="getLogs"></v-select>

          </v-col>
          <v-col class="text-right m-0" tag="strong" cols="3">

            <v-select v-model="mes"
                      :items="meses"
                      placeholder="Mes"
                      item-text="nombre"
                      item-value="index"
                      hide-details
                      single-line
                      clearable
                      class=" p-0 m-0 ml-3"></v-select>

          </v-col>
        </v-row>

        <v-row class="pa-4 mt-0" justify="space-between">

          <v-col class="d-flex text-center">
            <v-scroll-y-transition mode="out-in">
              <v-card class="pt-0 mx-auto" flat outlined width="100%">
                <v-progress-linear color="primary" indeterminate v-if="loaddata"></v-progress-linear>
                <v-row class="text-left m-0 p-0" tag="v-card-text">
                  <v-col class="text-right m-0" cols="12">
                    <v-btn outlined color="success" :loading="loading_excel" @click.prevent="downloadLogs" :disabled="fileInfo.length == 0">
                      <i class="fa fa-file-excel mr-2"></i> Registros
                    </v-btn>
                  </v-col>
                </v-row>

                <v-row class="text-left m-0 p-0" tag="v-card-text">
                  <v-col>
                    <v-data-table :headers="headers" :items="fileInfo" :footer-props="listSize" :options.sync="pagination" :items-per-page="10" class="elevation-0 rounded-0 border-top">
                      <template v-for="(itm, i) in headers" v-slot:[getSlotName(itm.value)]="{ item }">
                        {{ item[itm.value] | text(100) }}
                      </template>
                      <template v-slot:item.acciones="{ item }">
                        <div class="d-flex justify-content-center">
                          <b-button @click.prevent="read(item)" class="btn-s edit mr-2" variant="success">
                            <i class="fas fa-ellipsis-h"></i></b-button>
                          <br>
                        </div>
                      </template>
                    </v-data-table>

                  </v-col>
                </v-row>
              </v-card>
            </v-scroll-y-transition>
          </v-col>

        </v-row>
      </div>
    </div>
    <v-dialog v-model="dialog" scrollable max-width="600">
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          Informe de registro
        </v-card-title>

        <v-card-text>
          <v-timeline
                      align-top
                      dense>
            <v-timeline-item
                             v-for="(item, i) in dialogData"
                             :key="i"
                             small>
              <div>
                <div class="font-weight-normal">
                  <strong>{{ i }}</strong>
                </div>
                <div>{{ item }} </div>
              </div>
            </v-timeline-item>
          </v-timeline>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
                 color="primary"
                 text
                 @click="dialog = false">
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import moment from 'moment'
import Vue from 'vue'
import excel from 'vue-excel-export'
export default {
  components: {

  },
  data () {
    return {
      active: [],
      logs: [],
      loading_excel: false,
      dialog: false,
      dialogData: {},
      log: {},
      open: [],
      search: '',
      periodo: '',
      mes: '',
      meses: [
        { index: '1', nombre: 'Enero' },
        { index: '2', nombre: 'Febrero' },
        { index: '3', nombre: 'Marzo' },
        { index: '4', nombre: 'Abril' },
        { index: '5', nombre: 'Mayo' },
        { index: '6', nombre: 'Junio' },
        { index: '7', nombre: 'Julio' },
        { index: '8', nombre: 'Agosto' },
        { index: '9', nombre: 'Septiembre' },
        { index: '10', nombre: 'Octubre' },
        { index: '11', nombre: 'Noviembre' },
        { index: '12', nombre: 'Diciembre' }
      ],
      caseSensitive: false,
      loaddata: false,
      fileInfo: [],
      headers: [],
      dataExcelRegistro: [],
      dataExcelSinMovimientos: [],
      dataExcelErrores: [],
      meta: [
        [{
          'key': 'charset',
          'value': 'utf-8'
        }]
      ],
      campos_excel: {},
      // file_name: '',
      listSize: {
        itemsPerPageOptions: [10, 25, 50, 100]
      },
      pagination: {
        page: 1,
        itemsPerPage: 10
      }
    }
  },
  watch: {
    '$route': 'checkPermissions'
  },
  computed: {
    logList () {
      var list = this.logs
      if (this.mes) {
        list = this.logs.filter(l => {
          return parseInt(this.extractDate(l.nombre, 'MM')) === parseInt(this.mes)
        })
      }

      this.log = list.length ? this.logs[0] : {}
      this.getJsonFile(this.log)

      return list
    },
    periodos_ () {
      if (this.periodos) {
        return this.periodos.filter(p => p.year >= 2023)
      }
      return []
    }
  },
  methods: {
    read (item) {
      this.dialog = true
      this.dialogData = item
    },
    getSlotName (slot) {
      return 'item.' + slot
    },
    formatMax (value) {
      console.log(value)
      if (value) {
        let len = 100
        return value.substr(0, len) + (value.length > len ? '...' : '')
      }
      return ' '
    },
    checkPermissions () {
      let permiso = [29]
      if (!this.getKey('permisos').some(r => permiso.includes(r))) {
        localStorage.clear()
        this.$router.push('/login')
        this.$router.go()
      }
    },
    async getLogs () {
      var params = {
        params: {
          periodo: this.periodo
        }
      }
      this.$http.get('log_files', params).then(
        response => {
          this.logs = response.data.archivos

          this.log = this.logs.length ? this.logs[0] : {}

          // this.meses = this.logs.map(l => {
          //   return this.extractDate(l.nombre)
          // })
        },
        error => {
          this.StepError(error)
        }
      )
    },
    downloadLogs () {
      this.loading_excel = true
      var params = {
        anio: this.log.anio,
        nombre: this.log.nombre,
        ruta: this.log.ruta
      }
      this.$http.get('log_file_download', { params, responseType: 'arraybuffer' }).then(
        response => {
          let blob = new Blob([response.data], { type: 'application/octet-stream' })
          //   console.log(blob);
          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = this.log.nombre
          link.click()

          this.loading_excel = false
        },
        error => {
          this.loading_excel = false
          this.StepError(error)
        }
      )
    },
    async getJsonFile (file) {
      this.fileInfo = []
      if (file) {
        // this.file_name = file.replace(/\.[^/.]+$/, '')
        this.loaddata = true
        this.dataExcelRegistro = []

        var params = {
          params: {
            anio: file.anio,
            nombre: file.nombre,
            ruta: file.ruta
          }
        }

        this.$http.get('log_file', params).then(response => {
          this.loaddata = false
          this.headers = []
          if (response.data.headers.length > 0) {
            this.headers = [{
              text: 'Acciones',
              align: 'center',
              sortable: false,
              value: 'acciones',
              class: '',
              width: 80
            }]

            response.data.headers.forEach(header => {
              this.campos_excel[header] = header
              this.headers.push({
                text: header,
                value: header,
                align: 'center',
                sortable: false
              })
            })
          }

          this.fileInfo = response.data.file
          this.dataExcelRegistro = response.data.file
        }, error => {
          this.StepError(error)
          this.loaddata = false
        })
      }
    },
    extractDate (text, format = 'DD/MM/YYYY') {
      const regex = /^log_(\d{4}-\d{2}-\d{2})\.csv$/
      const match = text.match(regex)

      if (match) {
        const fecha = moment(match[1], 'YYYY-MM-DD')

        return fecha.format(format)
      }
      return ''
    }

  },
  created () {
    this.getLogs()
    this.periodo = new Date().getFullYear()
    this.checkPermissions()
  },
  mounted () {
    this.checkCatalogs()
  }
}

</script>
<style>
.v-text-field.v-text-field--solo .v-input__control input {
  border: none !important;
}

.v-label.theme--dark {
  color: #fff !important;
}

.theme--light.v-divider {
  border-top: 1px solid rgba(0, 0, 0, 0.12) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Reportes/LogReport.vue